import AdminAppContainer from "./AdminAppContainer";
import AdminAppCardWrapper from "./AdminAppCardWrapper";
import AdminAppCardHeader from "./AdminAppCardHeader";
import AdminAppForm from "./AdminAppForm";

export default function AdminAppChild({ data, onCancel }) {
  return (
    <AdminAppContainer>
      <AdminAppCardWrapper>
        <AdminAppCardHeader data={data} onCancel={onCancel} />
        <AdminAppForm updateData={data} onCancel={onCancel} isEdit={true} />
      </AdminAppCardWrapper>
    </AdminAppContainer>
  );
}
